"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebviewContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ResponsiveContext_1 = require("@alfalab/core-components/side-panel/ResponsiveContext");
const dark_1 = __importDefault(require("@alfalab/core-components/themes/dark"));
const mobile_1 = __importDefault(require("@alfalab/core-components/themes/mobile"));
const component_context_1 = require("../context/component.context");
const defaultAdditionalContext = {
    isDesktop: false,
    isMobile: true,
    isResponsive: false,
    actionsHeight: 0,
    setActionsHeight: () => null,
    bodyGreed: false,
    setBodyGreed: () => null,
    platform: 'mobile',
};
const defaultResponseContext = {
    view: 'mobile',
    size: 500,
};
const prefixTheme = (theme, appId) => appId ? theme.replace(/--/g, `--${appId}-`) : theme;
/**
 * <SidePanel.WebviewContextProvider>
 *
 * Context provider для SidePanel в окружении webview.
 * Необходим ввиду того, что AdditionalContext и ResponsiveContext
 * теряются при подгрузке вебвью версии сайд-панели.
 *
 * Так же необходим для инициализации темной темы внутри сайд-панели.
 */
const WebviewContextProvider = ({ children, appId, additionalContext, responsiveContext, theme, }) => {
    const additionalContextValue = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, defaultAdditionalContext), additionalContext)), [additionalContext]);
    const responsiveContextValue = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, defaultResponseContext), responsiveContext)), [responsiveContext]);
    const { mobileThemePrefixed, darkThemePrefixed } = (0, react_1.useMemo)(() => ({
        mobileThemePrefixed: prefixTheme(mobile_1.default, appId),
        darkThemePrefixed: prefixTheme(dark_1.default, appId),
    }), [appId]);
    return ((0, jsx_runtime_1.jsx)(component_context_1.AdditionalContext.Provider, { value: additionalContextValue, children: (0, jsx_runtime_1.jsxs)(ResponsiveContext_1.ResponsiveContext.Provider, { value: responsiveContextValue, children: [(0, jsx_runtime_1.jsx)("style", { children: mobileThemePrefixed }), theme === 'dark' && (0, jsx_runtime_1.jsx)("style", { children: darkThemePrefixed }), children] }) }));
};
exports.WebviewContextProvider = WebviewContextProvider;
